import { Component, OnInit, inject } from '@angular/core';
import {ModalConfig} from '../modal-config';
import {ModalRef} from '../modal-ref';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.css'],
    standalone: true
})
export class ConfirmComponent implements OnInit {
  config = inject(ModalConfig);
  modal = inject(ModalRef);

  public inputData;

  constructor() {
    this.inputData = this.config.data;
  }

  ngOnInit() {
  }
  cancel() {
    this.modal.close(false);
  }
  confirm() {
    this.modal.close(true);
  }
}
